import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { ref as storageRef, listAll, getDownloadURL } from "firebase/storage";
import { db, storage } from "./firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function HouseBills() {
  const [listingIds, setListingIds] = useState([]);
  const [filteredIds, setFilteredIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedListing, setSelectedListing] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  // --- Load all Listing IDs ---
  useEffect(() => {
    const fetchListingIds = async () => {
      try {
        const snap = await getDocs(collection(db, "house-listings"));
        const ids = snap.docs.map((d) => d.id);
        setListingIds(ids);
        setFilteredIds(ids); // Initially show all
      } catch (err) {
        console.error(err);
        toast.error("Failed to load listing IDs");
      }
    };
    fetchListingIds();
  }, []);

  // --- Handle search ---
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = listingIds.filter((id) =>
      id.toLowerCase().includes(value)
    );
    setFilteredIds(filtered);
  };

  // --- Fetch images for a listing ---
  const fetchImages = async (listingId) => {
    try {
      setLoading(true);
      setSelectedListing(listingId);
      setImages([]);

      const folderRef = storageRef(storage, `housebills/${listingId}`);
      const res = await listAll(folderRef);

      if (res.items.length === 0) {
        toast.info("No images found for this listing");
        setImages([]);
        return;
      }

      const urls = await Promise.all(res.items.map((item) => getDownloadURL(item)));
      setImages(urls);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch images");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="housebills-page">
      <ToastContainer position="top-right" />
      <h2>Verify House Bills</h2>

      {/* Search Bar */}
      <div className="search-bar" style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Search by Listing ID"
          value={searchTerm}
          onChange={handleSearch}
          style={{
            padding: "8px",
            width: "250px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        />
      </div>

      <div className="listing-ids">
        <h4>All Listings</h4>
        <ul>
          {filteredIds.length > 0 ? (
            filteredIds.map((id) => (
              <li
                key={id}
                onClick={() => fetchImages(id)}
                style={{
                  cursor: "pointer",
                  fontWeight: selectedListing === id ? "bold" : "normal",
                  marginBottom: "5px",
                }}
              >
                {id}
              </li>
            ))
          ) : (
            <p>No listings match your search.</p>
          )}
        </ul>
      </div>

      {loading && <p>Loading images...</p>}

      {images.length > 0 && (
        <div className="images-grid">
          {images.map((url, index) => (
            <div key={index} className="image-card">
              <img src={url} alt={`bill-${index}`} style={{ width: "300px", height: "auto" }} />
            </div>
          ))}
        </div>
      )}

      {!loading && selectedListing && images.length === 0 && <p>No images for this listing.</p>}
    </div>
  );
}
